module.exports = __webpack_public_path__ + "img/small-hero-3.3ec6c349.webp";